import httpUtils from '../../utils/HttpUtils'

class CarouselService {

  //获取文章列表信息
  async list(category = '') {
    let result = null;
    try {
      result = await httpUtils.post('/cms/carousel/list',{category})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new CarouselService()
